import React from 'react';
import './index.scss';

export const InteractiveMap = ({ url, height }) => {
  return (
    <div className="map-viewer-iframe__wrapper">
      <iframe
        title="map-viewer-iframe"
        id="map-viewer-iframe"
        sandbox="allow-scripts allow-same-origin"
        height={height}
        src={url}
      ></iframe>
    </div>
  );
};
